import { moduleFactory } from "@/factories/module";
import {
  convertEncodedContentToNoteContent,
  convertMdxToEncodedContent,
  convertMdxToNoteContent,
} from "@/modules/notes/conversions";
import { shouldAutoCleanUp } from "@/modules/notes/auto-cleanup-policy";

export const notesModule = moduleFactory.create({
  convertMdxToNoteContent,
  convertEncodedContentToNoteContent,
  convertMdxToEncodedContent,
  shouldAutoCleanUp,
});
